import { getCookie } from 'cookies-next'

export const EVENT_TRACKING_STORAGE_KEY = 'ts_track'
export const PAGE_TRACKING_STORAGE_KEY = 'ts_page'
export const PAGE_SOURCE_TRACKING_STORAGE_KEY = 'ts_page_source'
export const identifier = { project: 'sirius' }

const consentCookieName = process.env.NEXT_PUBLIC_CONSENT_COOKIE_NAME as string
const analyticsCookieName = process.env.NEXT_PUBLIC_CONSENT_COOKIE_ANALYTICAL as string

export function trackingAllowed() {
  return String(getCookie(consentCookieName)).includes(analyticsCookieName)
}

export function analyticsAvailable() {
  return Boolean(global && global.analytics && typeof global.analytics.track === 'function')
}

export { track } from './track'
export { page, pageSource } from './page'
export { processTrackingStorage } from './storage'
export { setTrackingIdentity } from './setTrackingIdentity'
export { resetTrackingIdentity } from './resetTrackingIdentity'
